<template>

  <main id="main" class="blog2">
    
    <!-- ======= Single Blog Section ======= -->
    <section class="hero-section inner-page blog">
      <div class="wave">
        <svg
          width="1920px"
          height="265px"
          viewBox="0 0 1920 265"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="Apple-TV"
              transform="translate(0.000000, -402.000000)"
              fill="#FFFFFF"
            >
              <path
                d="M0,439.134243 C175.04074,464.89273 327.944386,477.771974 458.710937,477.771974 C654.860765,477.771974 870.645295,442.632362 1205.9828,410.192501 C1429.54114,388.565926 1667.54687,411.092417 1920,477.771974 L1920,667 L1017.15166,667 L0,667 L0,439.134243 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </svg>
      </div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="row justify-content-center">
              <div class="col-md-10 text-center hero-text">
                <h1 data-aos="fade-up" data-aos-delay="">
                  How to hide your API key
                </h1>
                <h4 data-aos="fade-up" data-aos-delay="">
                  Prevent theft by securing your API keys
                </h4>
                <p class="mb-5" data-aos="fade-up" data-aos-delay="100">
                  &bullet; By
                  <a href="#" class="text-white">Andreas Braumann</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="site-section mb-4 mt-5">
      <div class="container">
        <div class="row">
          <div class="col-md-8 blog-content">
            <h3>How to hide your API key</h3>
            <p>
              There are numerous API providers that require you to use a
              personal API key on the front end. Examples of such providers are
              Google Maps, YouTube, MailChimp, Paddle or PayPal.
            </p>
            <p>Generally you don't want to expose those api keys at all. This includes</p>
            <ul>
              <li>Source code repositories</li>
              <li>On your frontend</li>
              <li>Within your team</li>
            </ul>

            <div class="row mb-5">
              <div class="col-md-6">
                <figure>
                  <img src="/img/blog/keys.jpg" class="img-fluid" />
                </figure>
              </div>
              <div class="col-md-6">
                <!-- <figure><img src="/img/blog/keys.jpg" class="img-fluid">
                                </figure> -->
              </div>
            </div>
            <div>
              <h1>Encrypting the API key</h1>
              <p>For the front end it is much harder to secure your API key. For the browser to send a request to the API it has to include the API key somehow. That means that at some time the API key has to be present in clear text. As all the front end code is open to inspect for everyone it is very easy to find that key and potentially use it for malicious purposes.</p>
            </div>
            <div>
              <h1>API keys are valuable</h1>
              <p>Nowadays this really imposes not only a security risk but also a financial risk. Bots are checking all commits of public GitHub repos immediately for API keys and forward them to fraudsters. Read what happened to <a class="a-default-color" href="https://medium.com/@morgannegagne/a-very-expensive-aws-mistake-56a3334ed9ad">Morganne Gagne</a> when she committed her AWS S3 (Simple Storage Server) API key to her repo and was billed more than $7,000 in only one day!</p>
            </div>
            <div>
              <h1>Roll your own relay back end</h1>
              <p>When you run your own back end you can always write your own relay service that injects your api key. While this is a viable solution it increases your effort. But what if you have a front end application without a back end like a static site or if you use a CMS like Wordpress? You are out of luck hiding your API key!</p>
            </div>
            <div>
              <h1>Encrypt the key on the front end</h1>
              <p>There have been attempts to encrypt the API key on the front end but a quick <a class="a-default-color" href="https://stackoverflow.com/questions/52444630/is-there-a-way-to-secure-an-api-key-on-a-frontend-page">search on stack overflow</a>. Still this will never be a fully working solution as you will transmit the API key in plain text at some point.</p>
            </div>
            <div>
              <h1>How you can really hide your API key</h1>
              <p>Now there is an easy solution to this problem! Using hideAPIkey.com you store your secret API key in our database. Using our very own unique relay API we forward all your api parameters to the real API and inject the api key on the server. If you want to secure access to the relay api even more you can limit access to your hostname so nobody else can call it. This way your API key is never exposed to the front end and you can safely use any APIs without worrying about unexpected costs. hideAPIkey.com is even free for 24 hours!</p>
            </div>
            <!-- <div class="pt-5">
              <p>
                Categories: <a href="#">Design</a>, <a href="#">Events</a> Tags:
                <a href="#">#html</a>, <a href="#">#trends</a>
              </p>
            </div> -->
          </div>
          <!--<div class="col-md-4 sidebar">
            <div class="sidebar-box pt-0">
              <h3>Paragraph</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Ducimus itaque, autem necessitatibus voluptate quod mollitia
                delectus aut, sunt placeat nam vero culpa sapiente consectetur
                similique, inventore eos fugit cupiditate numquam!
              </p>
            </div>
            <div class="sidebar-box pt-0">
              <img
                src="/img/andreas_braumann.png"
                alt="Image placeholder"
                class="img-fluid mb-4 shadow author"
              />
              <h3>About The Author</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Ducimus itaque, autem necessitatibus voluptate quod mollitia
                delectus aut, sunt placeat nam vero culpa sapiente consectetur
                similique, inventore eos fugit cupiditate numquam!
              </p>
            </div>
          </div>-->
        </div>
      </div>
    </section>
    <!-- ======= CTA Section ======= -->
    <section class="section cta-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 mr-auto text-center text-md-left mb-5 mb-md-0">
            <h2 class="mb-0">Interested in API key security?</h2>
          </div>
          <div class="col-md-5 text-center text-md-right">
            <form action="">
              <div class="news-letter">
                <input type="email" placeholder="Enter Your Email" />
                <button><span class="height-0 icon la la-angle-right"></span></button>
              </div>
            </form>
            <p class="text-white mb-0">
              Sign up for our hideAPIkey.com newsletter and security related
              information for your front-end.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- End CTA Section -->
  </main>
</template>
<script>
import HideApiKeyWidget from "../components/HideApiKeyWidget.vue";
import attachBanner from "../../node_modules/@beyonk/gdpr-cookie-consent-banner/dist/esm/bundle.js";
import { BAvatar } from "bootstrap-vue/esm/components/avatar/avatar";

export default {
  name: "home",
  components: {
    HideApiKeyWidget,
    BAvatar,
  },
  mounted() {
    const options = {
      /**
       * You must set the cookie name.
       **/
      cookieName: "hideapikey_gdpr",

      /**
       * The cookie configuration, such as domain and path.
       **/
      cookieConfig: {
        domain: "hideapikey.com",
        path: "/",
      },

      /**
       * These are the top two lines of text on the banner
       * The 'description' field can include html such as links
       **/
      heading: "GDPR Notice",
      description:
        'We use cookies to offer a better browsing experience, analyze site traffic, personalize content, and serve targeted advertisements. Please review our <a href="/privacy-policy">privacy policy page</a>. By clicking accept, you consent to our privacy policy & use of cookies.',

      /**
       * All the button labels
       **/
      acceptLabel: "Accept",
      settingsLabel: "Preferences",
      closeLabel: "Close window",

      /**
       * These are the default opt-ins and their descriptions.
       * When value is set to true, the option will automatically be checked on load.
       *
       * If you don't want to show a category, simply remove the specified key from this object.
       **/
      choices: {
        necessary: {
          label: "Required cookies",
          description:
            "These can't be turned off as they are used to control all the other cookies",
          value: true,
        },
        analytics: false,
      },

      /**
       * Show an icon to edit cookies later, when banner is closed.
       **/
      showEditIcon: true,

      /**
       * These are the functions which are run if a user opts-in to that category.
       * You should drop your cookies here (or set a variable to control the later dropping of cookies.
       *
       * If you are using svelte, you can use events instead - see the Svelte section below.
       **/
      categories: {
        tracking: function () {
          let themejs = document.createElement("script");
          themejs.setAttribute(
            "src",
            "https://www.googletagmanager.com/gtag/js?id=G-Z1K6RVY03J"
          );
          document.head.appendChild(themejs);

          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag("js", new Date());

          gtag("config", "G-Z1K6RVY03J");
        },
        marketing: function () {},
        necessary: function () {},
      },
    };
    attachBanner(this.$refs.gdprBanner, options);
  },
};
</script>
<style scoped>
@import "../../node_modules/@beyonk/gdpr-cookie-consent-banner/dist/style.css";
</style>
